import React from 'react';
import PropTypes from 'prop-types';

export const Info = ({ className, text, children }) => {
  let content;

  if (text) {
    return <p className={className}>{content}</p>;
  }
  return children;
};

Info.propTypes = {
  className: PropTypes.string
};

Info.defaultProps = {
  className: "admin-common-info"
};
